import React from "react";
import PanelExtended, {PanelHeader} from "../../Common/Components/PanelExtended.jsx";
import {FormattedMessage} from "react-intl";
import CloseBtn from "./CloseBtn.jsx";

const TeamDetailsPanelNotSupported = ({team, game}) => {

    if (!team) {
        return null
    }
    if (!team.notSupported) {
        return null
    }
    return <div className="team-details__teams-panel">
        <PanelExtended>
            <PanelHeader className="team-details__header" title={game.name}>
                <h3 className="team-details__name">{team.name}</h3>
                <CloseBtn game={game}/>
            </PanelHeader>
        </PanelExtended>
        <div className="alert alert-warning">
            <FormattedMessage id="details.notSupported" values={{
                name: <strong>{team.name}</strong>
            }}/>
        </div>
    </div>
};

export default TeamDetailsPanelNotSupported